<template>
  <va-sidebar
    :width="width"
    :minimized="minimized"
    :minimized-width="minimizedWidth"
    :animated="animated"
    style="background-color: #000"
    class="text-white"
  >
    <div class="flex justify-between items-center mb-4">
      <router-link to="/">
        <logo class="w-36 h-16 ml-4 mt-2" :is-blacked="false" />
        <!-- <h1 class="font-bold text-white text-2xl pl-2">RESERVE</h1> -->
      </router-link>
      <button class="pl-3 pt-2" @click="isSidebarMinimized = !isSidebarMinimized">
        <VaIcon v-if="isFullscreen" name="close" size="large" color="#fff"></VaIcon>
      </button>
    </div>
    <menu-minimized v-if="minimized" :items="items" :pending-applications-count="pendingReviewApplicationsCount" />
    <menu-accordion v-else :items="items" :pending-applications-count="pendingReviewApplicationsCount" class="mb-20" />

    <div class="bottom-6 absolute w-full px-2">
      <va-sidebar-item :active="isProfileActive" :to="{ name: 'profile' }">
        <va-sidebar-item-content>
          <va-icon name="material-icons-person" class="va-sidebar-item__icon text-white" />
          <va-sidebar-item-title class="text-white">My Account</va-sidebar-item-title>
        </va-sidebar-item-content>
      </va-sidebar-item>
      <button type="button" class="sidebar-logout-btn md:hidden" :disabled="isLoggingOut" @click="handleLogout">
        <va-icon name="logout" class="va-sidebar-item__icon text-white" />
        <span class="text-white">{{ isLoggingOut ? 'Logging out...' : 'Logout' }}</span>
      </button>
    </div>
  </va-sidebar>
</template>

<script setup lang="ts">
  import { computed, onMounted, ref, watch } from 'vue'
  import NavigationRoutes from './NavigationRoutes'
  import MenuAccordion from './menu/MenuAccordion.vue'
  import MenuMinimized from './menu/MenuMinimized.vue'
  import { storeToRefs } from 'pinia'
  import { useGlobalStore } from '@/stores/global-store'
  import Logo from '../Logo.vue'
  import { useRoute } from 'vue-router'

  const GlobalStore = useGlobalStore()

  const { isSidebarMinimized, userRole, pendingReviewApplicationsCount } = storeToRefs(GlobalStore)
  const route = useRoute()
  const isProfileActive = computed(() => route.name === 'profile')
  const isLoggingOut = ref(false)

  const handleLogout = async () => {
    if (isLoggingOut.value) return
    isLoggingOut.value = true
    try {
      await GlobalStore.logout()
    } finally {
      isLoggingOut.value = false
    }
  }

  withDefaults(
    defineProps<{
      width?: string
      color?: string
      animated?: boolean
      minimized?: boolean
      minimizedWidth?: string
      isFullscreen?: boolean
    }>(),
    {
      width: '16rem',
      color: 'secondary',
      animated: true,
      minimized: true,
      minimizedWidth: undefined,
    },
  )

  const items = ref(NavigationRoutes.routes)

  onMounted(() => {
    if (userRole.value === 'business_partner') {
      GlobalStore.loadPendingDriverApplications()
    }
  })

  watch(
    () => userRole.value,
    (role) => {
      if (role === 'business_partner') {
        GlobalStore.loadPendingDriverApplications()
      } else {
        pendingReviewApplicationsCount.value = 0
      }
    },
  )
</script>

<style lang="scss">
  .va-sidebar {
    &__menu {
      padding: 2rem 0;
    }

    &-item {
      &--active {
        background-color: #5e3a24 !important;
      }

      &__icon {
        width: 1.5rem;
        height: 1.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .sidebar-logout-btn {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    width: 100%;
    margin-top: 0.25rem;
    padding: 0.75rem 1rem;
    border: 0;
    border-radius: 0.375rem;
    background: transparent;
    cursor: pointer;
    text-align: left;

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    &:hover:not(:disabled) {
      background-color: rgba(255, 255, 255, 0.08);
    }
  }
</style>
